export default "__VITE_ASSET__B$AYe$jc__"